<template>
  <div>
    <facit-header ref="facitHeader"></facit-header>
    <div v-if="!payAsYouGo" class="main-div">
      <b-card-group deck class="mb-3">

        <b-card class="text-center card-background" @mouseover="activeLink = ''"
          @mouseleave="activeLink = null">
          <a class="link-decoration link-color-settings flex-container"
            :class="{ 'link-color-menu': activeLink === '' }">
            <div class="mt-30"> <v-icon name="user-plus" base-class="icon-width"></v-icon> </div>
            <div class="mt-3">Add User</div>
          </a>
        </b-card>
        <b-card class="text-center card-background " @mouseover="activeLink = 'admin/usageHistory'"
          @mouseleave="activeLink = null" :class="{ 'link-color-menu': activeLink === 'admin/usageHistory' }">
          <a @click="usageHistory()" class="link-decoration link-color-settings flex-container"
            :class="{ 'link-color-menu': activeLink === 'admin/usageHistory' }">
            <div class="flex-container">
              <div class="mt-30"> <v-icon name="clock" base-class="icon-width"></v-icon> </div>
              <div class="mt-3">Usage History</div>
            </div>
          </a>
        </b-card>
        <b-card class="text-center card-background" @mouseover="activeLink = 'admin/users'" @mouseleave="activeLink = null">
          <a @click="profile()" class="link-decoration link-color-settings flex-container"
            :class="{ 'link-color-menu': activeLink === 'admin/users' }">
            <div class="mt-30"> <v-icon name="users" base-class="icon-width"></v-icon> </div>
            <div class="mt-3">Users</div>
          </a>
        </b-card>


        <!-- <b-card class="text-center card-background"
      @mouseover="activeLink='profile'"
      @mouseleave="activeLink=null">
          <a
            @click="profile()"
            class="link-decoration link-color-settings flex-container"
            :class="{'link-color-menu': activeLink === 'profile'}">
          <div class="mt-30"> <v-icon name="user" base-class="icon-width"></v-icon> </div>
          <div class="mt-3">Update Profile</div>
        </a>
      </b-card>
      <b-card class="text-center card-background "
      @mouseover="activeLink='amount'"
      @mouseleave="activeLink=null"
      :class="{'link-color-menu': activeLink === 'amount'}">
        <div class="flex-container">
          <div class="mt-30"> <v-icon name="credit-card" base-class="icon-width"></v-icon> </div>
          <div class="mt-3"> Total Amount:  £{{credit}}</div>
          <div class="mt-3"> Contact us for pricing</div>
         </div>
      </b-card>
      <b-card class="text-center card-background"
      @mouseover="activeLink='device'"
      @mouseleave="activeLink=null">
        <a @click="management()"
        class="link-decoration link-color-settings flex-container"
        :class="{'link-color-menu': activeLink === 'device'}">
          <div class="mt-30"> <v-icon name="settings" base-class="icon-width"></v-icon> </div>
          <div class="mt-3">Device Management</div>
        </a>
      </b-card> -->
      </b-card-group>

      <!-- <b-card-group deck class="mb-3">
      <b-card class="text-center card-background"
      @mouseover="activeLink='invoice'"
      @mouseleave="activeLink=null">
        <a @click="invoice()"
        class="link-decoration link-color-settings flex-container"
        :class="{'link-color-menu': activeLink === 'invoice'}">
        <div class="flex-container">
          <div class="mt-30"> <v-icon name="file" base-class="icon-width"></v-icon> </div>
          <div class = "mt-3" > Invoices</div>
        </div>
      </a>
      </b-card>
      <b-card class="text-center card-background"
      @mouseover="activeLink='downloads'"
      @mouseleave="activeLink=null">
        <a @click="downloads()" class="link-decoration link-color-settings flex-container"
        :class="{'link-color-menu': activeLink === 'downloads'}">
        <div class="mt-30"> <v-icon name="download-cloud" base-class="icon-width"></v-icon> </div>
        <div class = "mt-3" > Downloads</div>
      </a>
      </b-card>
      <b-card
      class="text-center card-background"
      @mouseover="activeLink='support'"
      @mouseleave="activeLink=null">
        <div class="flex-container">
          <a
          @click="support()"
          class="link-decoration link-color-settings flex-container"
          :class="{'link-color-menu': activeLink === 'support'}">
          <div class="mt-30"> <v-icon name="phone" base-class="icon-width"></v-icon> </div>
          <div class = "mt-3" > Support</div>
        </a>
      </div>
      </b-card>
    </b-card-group> -->

    </div>

    <div v-else class="main-div">
      <b-card-group deck class="mb-3">
        <b-card class="text-center card-background" @mouseover="activeLink = 'profile'" @mouseleave="activeLink = null">
          <a @click="profile()" class="link-decoration link-color-settings flex-container"
            :class="{ 'link-color-menu': activeLink === 'profile' }">
            <div class="mt-30"> <v-icon name="user" base-class="icon-width"></v-icon> </div>
            <div class="mt-3">Update Profile</div>
          </a>
        </b-card>
        <b-card class="text-center card-background " @mouseover="activeLink = 'license'" @mouseleave="activeLink = null">
          <a @click="licence()" class="link-decoration link-color-settings flex-container"
            :class="{ 'link-color-menu': activeLink === 'license' }">
            <div class="mt-30"> <v-icon name="credit-card" base-class="icon-width"></v-icon> </div>
            <div class="mt-3">Pay as you go</div>
            <div class="mt-2">(Generate Key)</div>

          </a>
        </b-card>
        <b-card class="text-center card-background" @mouseover="activeLink = 'support'" @mouseleave="activeLink = null">
          <div class="flex-container">
            <a @click="support()" class="link-decoration link-color-settings flex-container"
              :class="{ 'link-color-menu': activeLink === 'support' }">
              <div class="mt-30"> <v-icon name="phone" base-class="icon-width"></v-icon> </div>
              <div class="mt-3"> Support</div>
            </a>
          </div>
        </b-card>
      </b-card-group>
    </div>
  </div>
</template>

<script>
import API from '@/api';
import Session from '@/Session';
import FacitHeader from '@/components/header';

export default {
  name: 'Dashboard',
  components: { FacitHeader },
  data() {
    const token = Session.getAccessToken();
    const payAsGo = token.user.payAsGo;
    return {
      credit: null,
      activeLink: null,
      AccountDetail: null,
      payAsYouGo: payAsGo,
    };
  },
  created() {
    this.getAccount();
    this.$eventHub.$on('credit-updated', this.getAccount);
  },
  beforeDestroy() {
    this.$eventHub.$off('credit-updated');
  },
  methods: {
    async getAccount() {
      const token = Session.getAccessToken();
      const userId = token.user.id;
      this.AccountDetail = await API.get(`Accounts/${userId}/`, { cache: false });
      this.payAsYouGo = this.AccountDetail.payAsGo
      this.credit = this.intToFloat(this.AccountDetail.credits, 2);
      Session.updateUser(this.AccountDetail);
    },
    intToFloat(num, decPlaces) {
      return num.toFixed(decPlaces);
    },
    support() {
      this.$router.push('support');
    },
    downloads() {
      this.$router.push('downloads');
    },
    invoice() {
      this.$router.push('invoice');
    },
    management() {
      this.$router.push('management');
    },
    licence() {
      this.$router.push('license');
    },
    profile() {
      // this.$router.push('profile');
      this.$router.push('admin/users')
    },
    usageHistory() {
      this.$router.push('admin/usageHistory')
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.mt-30 {
  margin-top: 30px;
}

.main-div {
  width: 80%;
  margin: 30px auto;
}

.card-background {
  background-color: #DCDCDC;
  height: 225px;
  text-align: center;
  border: 1px solid #eee;
}

.icon-width {
  width: 40px !important;
  height: 40px !important;
}

.buy-credits-button {
  float: left;
}

.flex-container {
  display: flex;
  align-items: center;
  flex-direction: column;
}

.icon-div {
  margin-top: 30px;
}

.link-decoration {
  text-decoration: none;
  cursor: pointer;
}

.link-color-settings {
  color: #2c3e50 !important;
}

.link-color {
  color: #90a4ae !important;
}

.btn-warning {
  color: #fff;
  background-color: #ff8f00;
  border-color: #ff8f00;
}

.link-color-hover {
  color: #fff;
}

.link-color-menu {
  color: #9da7b2 !important;
}

.help.is-danger {
  color: #ff3860;
}

.help {
  display: block;
  font-size: 11px;
  margin-top: 5px;
}

span {
  font-style: inherit;
  font-weight: inherit;
}

*,
:after,
:before {
  box-sizing: inherit;
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard.vue